export default __webpack_public_path__ + "static/media/Animals_04.cc72202e.png";